import React from "react";
import i18n from "i18next";
import Chart from "./components/chart-component";
import Config from "./components/config-component";
import ChartOptions from "./components/chart-options";

require("./_graficaD3.scss");
/* eslint-disable react/prop-types */

export function GraficaD3(base) {
  return {
    getConfig: function () {
      return {
        name: "GraficaD3",
        flavor: "react",
        displayName: IdealStudio.i18n.t("GraficaD3.PluginName"),
        category: "text",
        needsConfigModal: true,
        needsConfirmation: true,
        needsTextEdition: false,
        icon: "insert_chart",
        initialWidth: "700px",
        initialHeight: "300px",
        initialWidthSlide: "70%",
        initialHeightSlide: "60%",
        createFromLibrary: ["csv", "url"],
        searchIcon: false,
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            style: {
              __name: IdealStudio.i18n.t("GraficaD3.style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("GraficaD3.padding"),
                  type: "number",
                  value: 10,
                  min: 0,
                  max: 100,
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("GraficaD3.border_width"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("GraficaD3.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("GraficaD3.border_color"),
                  type: "color",
                  value: "#000000",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("GraficaD3.border_radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                  step: 5,
                  units: "%",
                },
                opacity: {
                  __name: IdealStudio.i18n.t("GraficaD3.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        dataProvided: [
          [
            IdealStudio.i18n.t("GraficaD3.example.example_name_surname_txt"),
            IdealStudio.i18n.t("GraficaD3.example.example_age_txt"),
          ],
          [
            IdealStudio.i18n.t("GraficaD3.example.examplename1"),
            IdealStudio.i18n.t("GraficaD3.example.exampleage1"),
          ],
          [
            IdealStudio.i18n.t("GraficaD3.example.examplename2"),
            IdealStudio.i18n.t("GraficaD3.example.exampleage2"),
          ],
        ],
        dataProcessed: [
          {
            name: IdealStudio.i18n.t("GraficaD3.example.examplename1"),
            0: IdealStudio.i18n.t("GraficaD3.example.examplename1"),
            1: IdealStudio.i18n.t("GraficaD3.example.exampleage1"),
          },
          {
            name: IdealStudio.i18n.t("GraficaD3.example.examplename2"),
            0: IdealStudio.i18n.t("GraficaD3.example.examplename2"),
            1: IdealStudio.i18n.t("GraficaD3.example.exampleage2"),
          },
        ],
        editing: true,
        options: {
          type: "area",
          xaxis: 0,
          graphs: [
            {
              column: 1,
              name: IdealStudio.i18n.t("GraficaD3.example.example_age_txt"),
              color: "#332ef0",
            },
          ],
          gridX: true,
          gridY: true,
        },
      };
    },
    getRenderTemplate: function (state, props) {
      return <Chart id={props.id} dataProcessed={state.dataProcessed} options={state.options} />;
    },
    getConfigTemplate: function (id, state, updateState, props) {
      return {
        component: (
          <Config id={id} state={state} updateState={updateState} props={props} step={props.step} />
        ),
        n_steps: 2,
      };
    },
  };
}
/* eslint-enable react/prop-types */
